/** @format */

import Moment from 'moment/moment';

function getDate(value) {
    let format = 'MM/DD/YYYY';
    return Moment(value).format(format);
}

export default function DateOnly({children}) {
    return getDate(children);
}

function getDateDiff(start, end, unit = 'days') {
    let diff = Moment(end).diff(Moment(start), unit);
    return diff;
}

function getDateTime(value) {
    let format = 'MM/DD/YYYY hh:mma';
    return Moment(value).format(format);
}
function DateTime({children}) {
    return getDateTime(children);
}

function DateFromNow({children, withoutSuffix = false}) {
    return Moment(children).fromNow(withoutSuffix);
}

// cutoffTime: string in 'HH:mm' format representing time in 'America/New_York' timezone
function IfBeforeCutoff({cutoffTime, children}) {
    const localCutoffTime = getLocalTime(cutoffTime);

    if (localCutoffTime > new Date()) {
        return children;
    }

    return null;
}

// Create a function to convert 10am et to local time
function getLocalTime(time) {
    // time: string in 'HH:mm' format representing time in 'America/New_York' timezone

    // Get the current date components in 'America/New_York' timezone
    const now = new Date();
    const nyDateComponents = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    }).formatToParts(now);

    // Extract the year, month, and day
    const dateParts = {};
    nyDateComponents.forEach(({type, value}) => {
        if (type !== 'literal') {
            dateParts[type] = value;
        }
    });

    // Combine the date components with the provided time
    const dateTimeString = `${dateParts.year}-${dateParts.month}-${dateParts.day}T${time}:00`;

    // Parse the date and time string as if it's in 'America/New_York' timezone
    const nyDate = new Date(dateTimeString);

    // Get the UTC timestamp corresponding to the time in 'America/New_York'
    const nyTimestamp = nyDate.getTime() - getTimeZoneOffsetInMs('America/New_York', nyDate);

    // Create a Date object in the user's local timezone using the timestamp
    const localDate = new Date(
        nyTimestamp +
            getTimeZoneOffsetInMs(Intl.DateTimeFormat().resolvedOptions().timeZone, nyDate)
    );

    return localDate;
}

function getTimeZoneOffsetInMs(timeZone, date) {
    const tzDateStr = date.toLocaleString('en-US', {timeZone});
    const tzDate = new Date(tzDateStr);
    return tzDate.getTime() - date.getTime();
}

export {DateFromNow, DateTime, getDateTime, getDate, getDateDiff, getLocalTime, IfBeforeCutoff};
